import React from 'react';
import { TimelineItemType } from 'types/TimelineTypes';
import { useTranslation } from 'react-i18next';
import { formatTimelineDate } from 'services/utils/dateTimeUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlug } from '@fortawesome/free-solid-svg-icons';

interface TimelineIntegrationNotificationProps {
    placement: 'summary' | 'page';
    item: TimelineItemType;
}

const TimelineIntegrationNotification: React.FC<TimelineIntegrationNotificationProps> = ({
    placement,
    item,
}) => {
    const { t } = useTranslation();

    const notification = item.integration_notification;

    if (!notification) {
        return null;
    }

    const formattedDate = formatTimelineDate(item.ordering_date, false);

    return (
        <div className={`timeline-item integration-notification ${notification.severity}`}>
            {placement === 'page' && (
                <div className='marker-container'>
                    <div className="big-marker">
                        <FontAwesomeIcon icon={faPlug} className='integration-notification-icon' />
                    </div>
                </div>
            )}

            <div className="update-content">
                {notification.title && (
                    <p className="update-text">
                        {t(`integrations.notifications.${notification.integration_name}.${notification.title}`)}
                    </p>
                )}

                <div>
                    <p className="update-info">
                        {formattedDate}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TimelineIntegrationNotification;